import { intl } from "LocaleWrapper";
import { FormGroup } from "@cofano/cck";
import Grid from "@mui/material/Grid2";
import { Fragment, ReactNode } from "react";
import type { AgreementDetailsByTypeProps } from "view/agreements/schema/schema";


type DetailsField = {
	id: string;
	render: () => ReactNode;
}

const BlockFreightAgreementDetails = ({ agreement, hiddenFields }: AgreementDetailsByTypeProps) => {

	const BlockFreightAgreementDetailsFields: DetailsField[] = [
		{
			id: "agreement.days",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "BLOCK_FREIGHT_DAYS" })} overflow="hidden">
						{agreement.days}
					</FormGroup>
				</Grid>
			),
		},
	];

	return (
		<>
			{BlockFreightAgreementDetailsFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default BlockFreightAgreementDetails;
